/** @format */

import "./css/App.css";

import { useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";

import BasicPricePage from "./pages/basic_price/BasicPricePage/BasicPricePage";
import BasicPriceEditPage from "./pages/basic_price/BasicPriceEditPage/BasicPriceEditPage";
import MarketPriceEditPage from "./pages/market_price/MarketPriceEditPage/MarketPriceEditPage";
import OrderFormConfirmPage from "./pages/order/OrderFormConfirmPage/OrderFormConfirmPage";
import OrderDataCheckPage from "./pages/order/OrderDataCheckPage/OrderDataCheckPage";
import CustomerSearchPage from "./pages/customer/CustomerSearchPage/CustomerSearchPage";
import CustomerInformationPage from "./pages/customer/CustomerInformationPage/CustomerInformationPage";
import CustomerInformationEditPage from "./pages/customer/CustomerInformationEditPage/CustomerInformationEditPage";
import CustomerRegistrationPage from "./pages/customer/CustomerRegistrationPage/CustomerRegistrationPage";
import ShopInformationPage from "./pages/shop/ShopInformationPage/ShopInformationPage";
import ShopInformationEditPage from "./pages/shop/ShopInformationEditPage/ShopInformationEditPage";
import ShopGroupEditPage from "./pages/shop/ShopGroupEditPage/ShopGroupEditPage";
import ShopRegistrationPage from "./pages/shop/ShopRegistrationPage/ShopRegistrationPage";

import MarketCalendarPage from "./pages/calendar/MarketCalendarPage/MarketCalendarPage";
import BasicClosedListPage from "./pages/basic_price/BasicClosedListPage/BasicClosedListPage";
import TemporaryScheduleListPage from "./pages/calendar/TemporaryScheduleListPage/TemporaryScheduleListPage";

import OrderEditPage from "./pages/order/OrderEditPage/OrderEditPage";

import IndexPage from "./pages/IndexPage";
import { createTheme, ThemeProvider } from "@mui/material";
import { grey } from "@mui/material/colors";
import CustomerSendGroupListPage from "./pages/customer/CustomerSendGroupListPage/CustomerSendGroupListPage";
import CustomerSendGroupMemberShopsPage from "./pages/customer/CustomerSendGroupMemberShopsPage/CustomerSendGroupMemberShopsPage";
import CustomerSendGroupEditPage from "./pages/customer/CustomerSendGroupEditPage/CustomerSendGroupEditPage";
import CustomerSendGroupRegistrationPage from "./pages/customer/CustomerSendGroupRegistrationPage/CustomerSendGroupRegistrationPage";

import ProductMasterPage from "./pages/product/ProductMasterPage/ProductMasterPage";
import ProductPage from "./pages/product/ProductPage/ProductPage";
import ProductEditPage from "./pages/product/ProductEditPage/ProductEditPage";
import ProductRegisterPage from "./pages/product/ProductRegisterPage/ProductRegisterPage";
import ProductDetailRegisterPage from "./pages/product/ProductDetailRegisterPage/ProductDetailRegisterPage";
import ProductDetailEditPage from "./pages/product/ProductDetailEditPage/ProductDetailEditPage";

import PersistentDrawerLeft from "./components/PersistentDrawer";

import { SetupInterceptors } from "./http/AxiosClient";
import { CompanyHomePage } from "./pages/CompanyHomePage";
import { ScreenStatusContext } from "./context/ScreenStatusContext";
import TransactionPage from "./pages/transaction";
import SalesRecordEntry from "./pages/sales_record/SalesRecordEntry";
import Container from "./pages/container";
import SalesReportConfirmation from "./pages/sales_record/SalesReportConfirmation";
import {
  AccountPayableConfirmation,
  AccountReceivableBalance,
} from "./pages/account";
import { BillingConfirmation, TransferConfirmation } from "./pages/billing";
import {
  BillingStatement,
  DeliveryGuide,
  DeliveryNote,
} from "./pages/bill_template";
import PrintManagePage from "./pages/invoice/PrintManagePage";
import ChainStoreEntry from "./pages/chain_store";
import VarPage from "./pages/var";
import VarEditPage from "./pages/var/VarEditPage";
import VarInsertPage from "./pages/var/VarInsertPage";
import StaffStockPage from "./pages/sales_record/StaffStockPage/StaffStockPage";
import BuyerPage from "./pages/buyer";
import BuyerInsertPage from "./pages/buyer/BuyerInsertPage";
import BuyerEditPage from "./pages/buyer/BuyerEditPage";
import SalesPurchaseTransferPage from "./pages/sales_record/SalesPurchaseTransferPage/SalesPurchaseTransferPage";
import CommodityOwnerPage from "./pages/commodity_owner";
import CommodityOwnerEditPage from "./pages/commodity_owner/CommodityOwnerEditPage";
import CommodityOwnerInsertPage from "./pages/commodity_owner/CommodityOwnerInsertPage";
import HandWrite from "./pages/handwrite/app/HandWrite";
import MarketPriceSettingRegisterPage from "./pages/market_price_setting/MarketPriceSettingRegisterPage/MarketPriceSettingRegisterPage";
import MarketPriceSettingEditPage from "./pages/market_price_setting/MarketPriceSettingEditPage/MarketPriceSettingEditPage";

import NewsListPage from "./pages/news/NewsList/NewsListPage";
import NewsEditPage from "./pages/news/NewsRegEdit/NewsEditPage";
import UserListPage from "./pages/user/UserList/UserListPage";
import UserEditPage from "./pages/user/UserEdit/UserEditPage";
import SupplyListPage from "./pages/supply/supplyList/SupplyListPage";
import SimpleOrderEntryPage from "./pages/order/SimpleOrderEntry/SimpleOrderEntryPage";
import OrderSummaryPage from "./pages/order/OrderSummaryPage/OrderSummaryPage";
import SalesRecordCollectiveEntryPage from "./pages/sales_record/SalesRecordCollectiveEntryPage/SalesRecordCollectiveEntryPage";
import CsvImportOrderPage from "./pages/order/CsvImportOrderPage/CsvImportOrderPage";

// システムベースURL定義
export const SYSTEM_PATH = "/";
export const SYSTEM_PATH_COMPANY = SYSTEM_PATH + "company";
export const SYSTEM_PATH_CUSTOMER = SYSTEM_PATH + "customer";

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            backgroundColor: grey[300],
          },
        },
      },
    },
  },
});

function NavigateFunctionComponent(props) {
  let navigate = useNavigate();
  const [ran, setRan] = useState(false);

  {
    /* only run setup once */
  }
  if (!ran) {
    SetupInterceptors(navigate);
    setRan(true);
  }
  return <></>;
}

export default function App() {
  // 画面ステータス
  const [isChanged, setChanged] = useState(false);

  const screenStatusValue = {
    isChanged,
    setChanged,
  };

  return (
    <ScreenStatusContext.Provider value={screenStatusValue}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          {<NavigateFunctionComponent />}
          <Routes>
            <Route path={SYSTEM_PATH} element={<IndexPage />} />
            {/* <Route path={SYSTEM_PATH_COMPANY} element={<CompanySiteHeader />}> */}
            <Route
              path={SYSTEM_PATH_COMPANY}
              element={<PersistentDrawerLeft />}
            >
              <Route path="home" element={<CompanyHomePage />} />
              <Route path="basic_price" element={<BasicPricePage />} />
              <Route path="basic_price_edit" element={<BasicPriceEditPage />} />
              <Route
                path="market_price_edit"
                element={<MarketPriceEditPage />}
              />
              <Route
                path="order_form_confirm"
                element={<OrderFormConfirmPage />}
              />
              <Route path="order_data_check" element={<OrderDataCheckPage />} />
              <Route path="customer_search" element={<CustomerSearchPage />} />
              <Route
                path="customer_information"
                element={<CustomerInformationPage />}
              />
              <Route
                path="customer_information_edit"
                element={<CustomerInformationEditPage />}
              />
              <Route
                path="customer_registration"
                element={<CustomerRegistrationPage />}
              />
              <Route
                path="shop_information"
                element={<ShopInformationPage />}
              />
              <Route
                path="shop_information_edit"
                element={<ShopInformationEditPage />}
              />
              <Route
                path="shop_registration"
                element={<ShopRegistrationPage />}
              />
              <Route path="shop_group_edit" element={<ShopGroupEditPage />} />
              
              <Route path="market_calendar" element={<MarketCalendarPage />} />
              <Route
                path="basic_closed_list"
                element={<BasicClosedListPage />}
              />
              <Route
                path="temporary_schedule_list"
                element={<TemporaryScheduleListPage />}
              />
              <Route
                path="customer_send_group_list"
                element={<CustomerSendGroupListPage />}
              />
              <Route
                path="customer_send_group_member_shops"
                element={<CustomerSendGroupMemberShopsPage />}
              />
              <Route
                path="customer_send_group_edit"
                element={<CustomerSendGroupEditPage />}
              />
              <Route
                path="customer_send_group_registration"
                element={<CustomerSendGroupRegistrationPage />}
              />
              <Route path="product_master" element={<ProductMasterPage />} />
              <Route path="product/" element={<ProductPage />} />
              <Route path="product_edit/" element={<ProductEditPage />} />
              <Route
                path="product_register/"
                element={<ProductRegisterPage />}
              />
              <Route
                path="product_detail_register/"
                element={<ProductDetailRegisterPage />}
              />
              <Route
                path="product_detail_edit/"
                element={<ProductDetailEditPage />}
              />
              <Route
                path="sales_record/register_entry/:salesRecordType"
                element={<SalesRecordEntry />}
              />
              <Route
                path="sales_record/collective_entry"
                element={<SalesRecordCollectiveEntryPage />} 
              />
              <Route
                path="sales_record/report_confirmation/"
                element={<SalesReportConfirmation />}
              />
              <Route
                path="sales_record/container_return_entry/"
                element={<Container />}
              />
              <Route
                path="sales_record/payment_entry/"
                element={<TransactionPage />}
              />
              <Route
                path="sales_record/receipt_entry/"
                element={<TransactionPage />}
              />
              <Route
                path='account_receivable_balance'
                element={<AccountReceivableBalance />}
              />
              <Route
                path='account_receivable_balance_monthly'
                element={<AccountReceivableBalance />}
              />
              <Route
                path='account_payable_confirmation'
                element={<AccountPayableConfirmation />}
              />
              <Route
                path='account_payable_confirmation_monthly'
                element={<AccountPayableConfirmation />}
              />
              <Route
                path="billing_confirmation"
                element={<BillingConfirmation />}
              />
              <Route path="delivery_note" element={<DeliveryNote />} />
              <Route path="delivery_guide" element={<DeliveryGuide />} />
              <Route path="billing_statement" element={<BillingStatement />} />
              <Route
                path="transfer_confirmation"
                element={<TransferConfirmation />}
              />
              <Route path="print/print_manage" element={<PrintManagePage />} />
              <Route path="entry/chain_store" element={<ChainStoreEntry />} />
              <Route path="var" element={<VarPage />} />
              <Route path="var_edit" element={<VarEditPage />} />
              <Route path="var_insert" element={<VarInsertPage />} />
              <Route path="staff_stock" element={<StaffStockPage />} />
              <Route path="buyer" element={<BuyerPage />} />
              <Route path="buyer_edit" element={<BuyerEditPage />} />
              <Route path="buyer_insert" element={<BuyerInsertPage />} />
              <Route path="sales_purchase_transfer" element={<SalesPurchaseTransferPage />} />
              <Route path="commodity_owner" element={<CommodityOwnerPage />} />
              <Route path="commodity_owner_edit" element={<CommodityOwnerEditPage />} />
              <Route path="commodity_owner_insert" element={<CommodityOwnerInsertPage />} />
              <Route path="handwrite" element={<HandWrite />} />
              <Route path="news_list" element={<NewsListPage />} />
              <Route path="news_edit" element={<NewsEditPage />} />
              <Route path="user_list" element={<UserListPage />} />
              <Route path="user_edit" element={<UserEditPage />} />
              <Route path="market_price_register" element={<MarketPriceSettingRegisterPage />} />
              <Route path="market_price_setting_edit" element={<MarketPriceSettingEditPage />} />
              <Route path="supply_list" element={<SupplyListPage />} />
              <Route path="simple_order_entry" element={<SimpleOrderEntryPage />} />
              <Route path="order_summary" element={<OrderSummaryPage />} />
              <Route path="csv_import_order" element={<CsvImportOrderPage />} />
            </Route>
            {/* <Route path={SYSTEM_PATH_CUSTOMER} element={<CustomerSiteHeader />}> */}
            <Route
              path={SYSTEM_PATH_CUSTOMER}
              element={<PersistentDrawerLeft />}
            >
              <Route path="order_edit" element={<OrderEditPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </ScreenStatusContext.Provider>
  );
}
